import { BASE_URL } from "../constants/url";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import {
  clearSessionAndRedirect,
  isUnauthorizedResponse,
} from "./sessionUtils";

const API_BASE_URL = BASE_URL;

const RATE_LIMIT_TOAST_ID = "api-rate-limit";

const notifyRateLimit = (message) => {
  const text = message || "Too many requests. Please try again later.";
  // One toast for many parallel 429s — does not change callers
  toast.error(text, {
    toastId: RATE_LIMIT_TOAST_ID,
    position: "top-right",
    autoClose: 5000,
  });
};

const isRateLimitedResponse = (response, data) => {
  if (response && response.status === 429) return true;
  if (!data || typeof data !== "object") return false;
  const rData = data.rData || data;
  const code = rData.rCode ?? data.rCode;
  return Number(code) === 429;
};

export const makeRequest = async ({
  endpoint,
  method = "POST",
  body = {},
  headers = {},
  eventID,
  addInfo = {},
}) => {
  try {
    const url = `${BASE_URL}${endpoint}`;
    const guid = localStorage.getItem("guid");
    console.log(guid);
    const defaultHeaders = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Headers": "Content-Type,*",
      "Access-Control-Allow-Credentials": "*",
      "Access-Control-Allow-Origin": url,
      "Access-Control-Allow-Methods": method,
      Accept: "application/json",
      guid: guid ? guid : uuidv4(),
      ...headers,
    };
    const token = localStorage.getItem("token");

    const roleID = Number(localStorage.getItem("roleId"));
    const userId = localStorage.getItem("userId");
    const sectionId = localStorage.getItem("sectionId");
    if (token) {
      defaultHeaders["Authorization"] = `Bearer ${token}`;
    }

    const requestBody = {
      roleID,
      userId,
      sectionId,
      eventID,
      addInfo: {
        ...addInfo,
        ...body,
      },
    };
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method,
      headers: defaultHeaders,
      body: JSON.stringify(requestBody),
    });

    let data = null;
    try {
      data = await response.json();
    } catch (parseError) {
      data = null;
    }

    // Login / change-password failures are not "session expired"
    const skipSessionKick =
      (endpoint === "Register" &&
        (String(eventID) === "1004" || String(eventID) === "1005")) ||
      String(endpoint).toLowerCase() === "logout";

    if (
      token &&
      !skipSessionKick &&
      isUnauthorizedResponse(response, data)
    ) {
      clearSessionAndRedirect({ redirect: true });
      throw new Error("Session expired. Please log in again.");
    }

    // Rate limit (HTTP 429 or rCode 429) — show API message, keep return shape
    if (isRateLimitedResponse(response, data)) {
      const rData = data?.rData || data;
      notifyRateLimit(rData?.rMessage || data?.rMessage);
    }

    return data?.rData;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};
